import { Link, useSearchParams } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";

/**
 * Sayfalama — query string'i (?page=N) korur, diğer paramları bozmaz.
 */
export function Pagination({ page, perPage, total, lang = "tr" }) {
  const totalPages = Math.max(1, Math.ceil(total / perPage));
  const [searchParams] = useSearchParams();

  if (totalPages <= 1) return null;

  const buildHref = (p) => {
    const params = new URLSearchParams(searchParams);
    if (p === 1) params.delete("page");
    else params.set("page", String(p));
    const qs = params.toString();
    return qs ? `?${qs}` : "";
  };

  const pages = pageWindow(page, totalPages);
  const prevDisabled = page <= 1;
  const nextDisabled = page >= totalPages;

  const dirArrow = lang === "ar"; // RTL'de ok yönlerini ters çevir

  return (
    <nav className="flex items-center justify-center gap-1.5 mt-12">
      <Link
        to={prevDisabled ? "#" : buildHref(page - 1)}
        aria-disabled={prevDisabled}
        onClick={(e) => prevDisabled && e.preventDefault()}
        className={`inline-flex items-center justify-center w-10 h-10 rounded-lg border transition-colors ${
          prevDisabled
            ? "text-slate-300 border-slate-100 cursor-not-allowed"
            : "text-slate-700 border-slate-200 hover:border-slate-300 hover:bg-slate-50"
        }`}
      >
        {dirArrow ? <ChevronRight className="w-4 h-4" /> : <ChevronLeft className="w-4 h-4" />}
      </Link>

      {pages.map((p, i) =>
        p === "…" ? (
          <span key={`ellipsis-${i}`} className="px-2 text-slate-400">
            …
          </span>
        ) : (
          <Link
            key={p}
            to={buildHref(p)}
            className={`inline-flex items-center justify-center w-10 h-10 text-sm font-medium rounded-lg border transition-colors ${
              p === page
                ? "bg-[#22A7D1] text-white border-[#22A7D1]"
                : "text-slate-700 border-slate-200 hover:border-slate-300 hover:bg-slate-50"
            }`}
          >
            {p}
          </Link>
        )
      )}

      <Link
        to={nextDisabled ? "#" : buildHref(page + 1)}
        aria-disabled={nextDisabled}
        onClick={(e) => nextDisabled && e.preventDefault()}
        className={`inline-flex items-center justify-center w-10 h-10 rounded-lg border transition-colors ${
          nextDisabled
            ? "text-slate-300 border-slate-100 cursor-not-allowed"
            : "text-slate-700 border-slate-200 hover:border-slate-300 hover:bg-slate-50"
        }`}
      >
        {dirArrow ? <ChevronLeft className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
      </Link>
    </nav>
  );
}

/** [1,2,3,…,N] tarzı pencere üret */
function pageWindow(current, total) {
  const window = new Set([1, total, current, current - 1, current + 1]);
  const sorted = [...window].filter((p) => p >= 1 && p <= total).sort((a, b) => a - b);
  const result = [];
  let prev = 0;
  for (const p of sorted) {
    if (p - prev > 1) result.push("…");
    result.push(p);
    prev = p;
  }
  return result;
}
